import React from 'react';
import TagInfo from '../../../../../../components/TagInfo';
import { TagInfoWarningIcon } from '../../../../../../components/TagInfoWarningIcon';

// import { Container } from './styles';

export const BloodProductInfo: React.FC = () => {
  return (
    <TagInfo
      type="WARNING"
      icon={<TagInfoWarningIcon />}
      info="Caso esteja participando de uma campanha de doação, selecione a unidade indicada pela empresa ou condomínio responsável."
    />
  );
};
